spApp.factory('SequenceCategories.api', [
  '$http',
  function ($http) {
    return {
      getList: () => $http.get('/instructional-sequences/categories', { params: { perPage: 100 } })
        .then(response => response.data)
    }
  }
]);
